import {LocaleInterface} from '../interfaces/locale.interface';

export const LOCALES_MAP: {[code in string]: LocaleInterface} = {
  "aa": { "code": "aa", "language": "Afar" },
  "aa-ER": { "code": "aa-ER", "language": "Afar (Eritrea)" },
  "af": { "code": "af", "language": "Afrikaans" },
  "af-NA": { "code": "af-NA", "language": "Afrikaans (Namibia)" },
  "af-ZA": { "code": "af-ZA", "language": "Afrikaans (South Africa)" },
  "ak": { "code": "ak", "language": "Akan" },
  "ak-GH": { "code": "ak-GH", "language": "Akan (Ghana)" },
  "am": { "code": "am", "language": "Amharic" },
  "am-ET": { "code": "am-ET", "language": "Amharic (Ethiopia)" },
  "ar": { "code": "ar", "language": "Arabic" },
  "ar-AE": { "code": "ar-AE", "language": "Arabic (United Arab Emirates)" },
  "ar-BH": { "code": "ar-BH", "language": "Arabic (Bahrain)" },
  "ar-DJ": { "code": "ar-DJ", "language": "Arabic (Djibouti)" },
  "ar-DZ": { "code": "ar-DZ", "language": "Arabic (Algeria)" },
  "ar-EG": { "code": "ar-EG", "language": "Arabic (Egypt)" },
  "ar-ER": { "code": "ar-ER", "language": "Arabic (Eritrea)" },
  "ar-IL": { "code": "ar-IL", "language": "Arabic (Israel)" },
  "ar-IQ": { "code": "ar-IQ", "language": "Arabic (Iraq)" },
  "ar-JO": { "code": "ar-JO", "language": "Arabic (Jordan)" },
  "ar-KM": { "code": "ar-KM", "language": "Arabic (Comoros)" },
  "ar-KW": { "code": "ar-KW", "language": "Arabic (Kuwait)" },
  "ar-LB": { "code": "ar-LB", "language": "Arabic (Lebanon)" },
  "ar-LY": { "code": "ar-LY", "language": "Arabic (Libya)" },
  "ar-MA": { "code": "ar-MA", "language": "Arabic (Morocco)" },
  "ar-MR": { "code": "ar-MR", "language": "Arabic (Mauritania)" },
  "ar-OM": { "code": "ar-OM", "language": "Arabic (Oman)" },
  "ar-PS": { "code": "ar-PS", "language": "Arabic (Palestine)" },
  "ar-QA": { "code": "ar-QA", "language": "Arabic (Qatar)" },
  "ar-SA": { "code": "ar-SA", "language": "Arabic (Saudi Arabia)" },
  "ar-SD": { "code": "ar-SD", "language": "Arabic (Sudan)" },
  "ar-SO": { "code": "ar-SO", "language": "Arabic (Somalia)" },
  "ar-SY": { "code": "ar-SY", "language": "Arabic (Syria)" },
  "ar-TD": { "code": "ar-TD", "language": "Arabic (Chad)" },
  "ar-TN": { "code": "ar-TN", "language": "Arabic (Tunisia)" },
  "ar-YE": { "code": "ar-YE", "language": "Arabic (Yemen)" },
  "as": { "code": "as", "language": "Assamese" },
  "as-IN": { "code": "as-IN", "language": "Assamese (India)" },
  "ay": { "code": "ay", "language": "Aymara" },
  "ay-BO": { "code": "ay-BO", "language": "Aymara (Bolivia)" },
  "az": { "code": "az", "language": "Azerbaijani" },
  "az-AZ": { "code": "az-AZ", "language": "Azerbaijani (Azerbaijan)" },
  "be": { "code": "be", "language": "Belarusian" },
  "be-BY": { "code": "be-BY", "language": "Belarusian (Belarus)" },
  "bg": { "code": "bg", "language": "Bulgarian" },
  "bg-BG": { "code": "bg-BG", "language": "Bulgarian (Bulgaria)" },
  "bm": { "code": "bm", "language": "Bambara" },
  "bm-ML": { "code": "bm-ML", "language": "Bambara (Mali)" },
  "bn": { "code": "bn", "language": "Bengali" },
  "bn-BD": { "code": "bn-BD", "language": "Bengali (Bangladesh)" },
  "bn-IN": { "code": "bn-IN", "language": "Bengali (India)" },
  "bo": { "code": "bo", "language": "Tibetan" },
  "bo-CN": { "code": "bo-CN", "language": "Tibetan (China)" },
  "bo-IN": { "code": "bo-IN", "language": "Tibetan (India)" },
  "br": { "code": "br", "language": "Breton" },
  "br-FR": { "code": "br-FR", "language": "Breton (France)" },
  "bs": { "code": "bs", "language": "Bosnian" },
  "bs-BA": { "code": "bs-BA", "language": "Bosnian (Bosnia and Herzegovina)" },
  "ca": { "code": "ca", "language": "Catalan" },
  "ca-AD": { "code": "ca-AD", "language": "Catalan (Andorra)" },
  "ca-ES": { "code": "ca-ES", "language": "Catalan (Spain)" },
  "ca-FR": { "code": "ca-FR", "language": "Catalan (France)" },
  "ca-IT": { "code": "ca-IT", "language": "Catalan (Italy)" },
  "ce": { "code": "ce", "language": "Chechen" },
  "ce-RU": { "code": "ce-RU", "language": "Chechen (Russia)" },
  "cs": { "code": "cs", "language": "Czech" },
  "cs-CZ": { "code": "cs-CZ", "language": "Czech (Czech Republic)" },
  "cy": { "code": "cy", "language": "Welsh" },
  "cy-GB": { "code": "cy-GB", "language": "Welsh (United Kingdom)" },
  "da": { "code": "da", "language": "Danish" },
  "da-DK": { "code": "da-DK", "language": "Danish (Denmark)" },
  "de": { "code": "de", "language": "German" },
  "de-AT": { "code": "de-AT", "language": "German (Austria)" },
  "de-BE": { "code": "de-BE", "language": "German (Belgium)" },
  "de-CH": { "code": "de-CH", "language": "German (Switzerland)" },
  "de-DE": { "code": "de-DE", "language": "German (Germany)" },
  "de-LI": { "code": "de-LI", "language": "German (Liechtenstein)" },
  "de-LU": { "code": "de-LU", "language": "German (Luxembourg)" },
  "dv": { "code": "dv", "language": "Divehi" },
  "dv-MV": { "code": "dv-MV", "language": "Divehi (Maldives)" },
  "dz": { "code": "dz", "language": "Dzongkha" },
  "dz-BT": { "code": "dz-BT", "language": "Dzongkha (Bhutan)" },
  "ee": { "code": "ee", "language": "Ewe" },
  "ee-GH": { "code": "ee-GH", "language": "Ewe (Ghana)" },
  "ee-TG": { "code": "ee-TG", "language": "Ewe (Togo)" },
  "el": { "code": "el", "language": "Greek" },
  "el-CY": { "code": "el-CY", "language": "Greek (Cyprus)" },
  "el-GR": { "code": "el-GR", "language": "Greek (Greece)" },
  "en": { "code": "en", "language": "English" },
  "en-AG": { "code": "en-AG", "language": "English (Antigua and Barbuda)" },
  "en-AI": { "code": "en-AI", "language": "English (Anguilla)" },
  "en-AS": { "code": "en-AS", "language": "English (American Samoa)" },
  "en-AU": { "code": "en-AU", "language": "English (Australia)" },
  "en-BB": { "code": "en-BB", "language": "English (Barbados)" },
  "en-BE": { "code": "en-BE", "language": "English (Belgium)" },
  "en-BM": { "code": "en-BM", "language": "English (Bermuda)" },
  "en-BS": { "code": "en-BS", "language": "English (Bahamas)" },
  "en-BW": { "code": "en-BW", "language": "English (Botswana)" },
  "en-BZ": { "code": "en-BZ", "language": "English (Belize)" },
  "en-CA": { "code": "en-CA", "language": "English (Canada)" },
  "en-GB": { "code": "en-GB", "language": "English (United Kingdom)" },
  "en-GD": { "code": "en-GD", "language": "English (Grenada)" },
  "en-GG": { "code": "en-GG", "language": "English (Guernsey)" },
  "en-GH": { "code": "en-GH", "language": "English (Ghana)" },
  "en-GI": { "code": "en-GI", "language": "English (Gibraltar)" },
  "en-GM": { "code": "en-GM", "language": "English (Gambia)" },
  "en-GU": { "code": "en-GU", "language": "English (Guam)" },
  "en-GY": { "code": "en-GY", "language": "English (Guyana)" },
  "en-HK": { "code": "en-HK", "language": "English (Hong Kong)" },
  "en-IE": { "code": "en-IE", "language": "English (Ireland)" },
  "en-IM": { "code": "en-IM", "language": "English (Isle of Man)" },
  "en-IN": { "code": "en-IN", "language": "English (India)" },
  "en-JE": { "code": "en-JE", "language": "English (Jersey)" },
  "en-JM": { "code": "en-JM", "language": "English (Jamaica)" },
  "en-KE": { "code": "en-KE", "language": "English (Kenya)" },
  "en-KI": { "code": "en-KI", "language": "English (Kiribati)" },
  "en-KN": { "code": "en-KN", "language": "English (Saint Kitts and Nevis)" },
  "en-KY": { "code": "en-KY", "language": "English (Cayman Islands)" },
  "en-LC": { "code": "en-LC", "language": "English (Saint Lucia)" },
  "en-LR": { "code": "en-LR", "language": "English (Liberia)" },
  "en-LS": { "code": "en-LS", "language": "English (Lesotho)" },
  "en-MG": { "code": "en-MG", "language": "English (Madagascar)" },
  "en-MH": { "code": "en-MH", "language": "English (Marshall Islands)" },
  "en-MO": { "code": "en-MO", "language": "English (Macau)" },
  "en-MP": { "code": "en-MP", "language": "English (Northern Mariana Islands)" },
  "en-MS": { "code": "en-MS", "language": "English (Montserrat)" },
  "en-MT": { "code": "en-MT", "language": "English (Malta)" },
  "en-MU": { "code": "en-MU", "language": "English (Mauritius)" },
  "en-MW": { "code": "en-MW", "language": "English (Malawi)" },
  "en-MY": { "code": "en-MY", "language": "English (Malaysia)" },
  "en-NA": { "code": "en-NA", "language": "English (Namibia)" },
  "en-NF": { "code": "en-NF", "language": "English (Norfolk Island)" },
  "en-NG": { "code": "en-NG", "language": "English (Nigeria)" },
  "en-NR": { "code": "en-NR", "language": "English (Nauru)" },
  "en-NU": { "code": "en-NU", "language": "English (Niue)" },
  "en-NZ": { "code": "en-NZ", "language": "English (New Zealand)" },
  "en-PG": { "code": "en-PG", "language": "English (Papua New Guinea)" },
  "en-PH": { "code": "en-PH", "language": "English (Philippines)" },
  "en-PK": { "code": "en-PK", "language": "English (Pakistan)" },
  "en-PN": { "code": "en-PN", "language": "English (Pitcairn Islands)" },
  "en-PR": { "code": "en-PR", "language": "English (Puerto Rico)" },
  "en-PW": { "code": "en-PW", "language": "English (Palau)" },
  "en-RW": { "code": "en-RW", "language": "English (Rwanda)" },
  "en-SB": { "code": "en-SB", "language": "English (Solomon Islands)" },
  "en-SC": { "code": "en-SC", "language": "English (Seychelles)" },
  "en-SD": { "code": "en-SD", "language": "English (Sudan)" },
  "en-SG": { "code": "en-SG", "language": "English (Singapore)" },
  "en-SH": { "code": "en-SH", "language": "English (Saint Helena)" },
  "en-SL": { "code": "en-SL", "language": "English (Sierra Leone)" },
  "en-SZ": { "code": "en-SZ", "language": "English (Swaziland)" },
  "en-TC": { "code": "en-TC", "language": "English (Turks and Caicos Islands)" },
  "en-TO": { "code": "en-TO", "language": "English (Tonga)" },
  "en-TT": { "code": "en-TT", "language": "English (Trinidad and Tobago)" },
  "en-TV": { "code": "en-TV", "language": "English (Tuvalu)" },
  "en-TZ": { "code": "en-TZ", "language": "English (Tanzania)" },
  "en-UG": { "code": "en-UG", "language": "English (Uganda)" },
  "en-US": { "code": "en-US", "language": "English (United States)" },
  "en-VC": { "code": "en-VC", "language": "English (Saint Vincent and the Grenadines)" },
  "en-VG": { "code": "en-VG", "language": "English (British Virgin Islands)" },
  "en-VI": { "code": "en-VI", "language": "English (U.S. Virgin Islands)" },
  "en-VU": { "code": "en-VU", "language": "English (Vanuatu)" },
  "en-WS": { "code": "en-WS", "language": "English (Samoa)" },
  "en-ZA": { "code": "en-ZA", "language": "English (South Africa)" },
  "en-ZM": { "code": "en-ZM", "language": "English (Zambia)" },
  "en-ZW": { "code": "en-ZW", "language": "English (Zimbabwe)" },
  "eo": { "code": "eo", "language": "Esperanto" },
  "es": { "code": "es", "language": "Spanish" },
  "es-AR": { "code": "es-AR", "language": "Spanish (Argentina)" },
  "es-BO": { "code": "es-BO", "language": "Spanish (Bolivia)" },
  "es-CL": { "code": "es-CL", "language": "Spanish (Chile)" },
  "es-CO": { "code": "es-CO", "language": "Spanish (Colombia)" },
  "es-CR": { "code": "es-CR", "language": "Spanish (Costa Rica)" },
  "es-DO": { "code": "es-DO", "language": "Spanish (Dominican Republic)" },
  "es-EC": { "code": "es-EC", "language": "Spanish (Ecuador)" },
  "es-ES": { "code": "es-ES", "language": "Spanish (Spain)" },
  "es-GT": { "code": "es-GT", "language": "Spanish (Guatemala)" },
  "es-HN": { "code": "es-HN", "language": "Spanish (Honduras)" },
  "es-MX": { "code": "es-MX", "language": "Spanish (Mexico)" },
  "es-NI": { "code": "es-NI", "language": "Spanish (Nicaragua)" },
  "es-PA": { "code": "es-PA", "language": "Spanish (Panama)" },
  "es-PE": { "code": "es-PE", "language": "Spanish (Peru)" },
  "es-PR": { "code": "es-PR", "language": "Spanish (Puerto Rico)" },
  "es-PY": { "code": "es-PY", "language": "Spanish (Paraguay)" },
  "es-SV": { "code": "es-SV", "language": "Spanish (El Salvador)" },
  "es-US": { "code": "es-US", "language": "Spanish (United States)" },
  "es-UY": { "code": "es-UY", "language": "Spanish (Uruguay)" },
  "es-VE": { "code": "es-VE", "language": "Spanish (Venezuela)" },
  "et": { "code": "et", "language": "Estonian" },
  "et-EE": { "code": "et-EE", "language": "Estonian (Estonia)" },
  "eu": { "code": "eu", "language": "Basque" },
  "eu-ES": { "code": "eu-ES", "language": "Basque (Spain)" },
  "fa": { "code": "fa", "language": "Persian" },
  "fa-IR": { "code": "fa-IR", "language": "Persian (Iran)" },
  "ff": { "code": "ff", "language": "Fulah" },
  "ff-SN": { "code": "ff-SN", "language": "Fulah (Senegal)" },
  "fi": { "code": "fi", "language": "Finnish" },
  "fi-FI": { "code": "fi-FI", "language": "Finnish (Finland)" },
  "fo": { "code": "fo", "language": "Faroese" },
  "fo-FO": { "code": "fo-FO", "language": "Faroese (Faroe Islands)" },
  "fr": { "code": "fr", "language": "French" },
  "fr-BE": { "code": "fr-BE", "language": "French (Belgium)" },
  "fr-BF": { "code": "fr-BF", "language": "French (Burkina Faso)" },
  "fr-BI": { "code": "fr-BI", "language": "French (Burundi)" },
  "fr-BJ": { "code": "fr-BJ", "language": "French (Benin)" },
  "fr-BL": { "code": "fr-BL", "language": "French (Saint Barthélemy)" },
  "fr-CA": { "code": "fr-CA", "language": "French (Canada)" },
  "fr-CD": { "code": "fr-CD", "language": "French (Congo - Kinshasa)" },
  "fr-CF": { "code": "fr-CF", "language": "French (Central African Republic)" },
  "fr-CG": { "code": "fr-CG", "language": "French (Congo - Brazzaville)" },
  "fr-CH": { "code": "fr-CH", "language": "French (Switzerland)" },
  "fr-CI": { "code": "fr-CI", "language": "French (Côte d’Ivoire)" },
  "fr-CM": { "code": "fr-CM", "language": "French (Cameroon)" },
  "fr-DJ": { "code": "fr-DJ", "language": "French (Djibouti)" },
  "fr-FR": { "code": "fr-FR", "language": "French (France)" },
  "fr-GA": { "code": "fr-GA", "language": "French (Gabon)" },
  "fr-GF": { "code": "fr-GF", "language": "French (French Guiana)" },
  "fr-GN": { "code": "fr-GN", "language": "French (Guinea)" },
  "fr-GP": { "code": "fr-GP", "language": "French (Guadeloupe)" },
  "fr-GQ": { "code": "fr-GQ", "language": "French (Equatorial Guinea)" },
  "fr-HT": { "code": "fr-HT", "language": "French (Haiti)" },
  "fr-KM": { "code": "fr-KM", "language": "French (Comoros)" },
  "fr-LU": { "code": "fr-LU", "language": "French (Luxembourg)" },
  "fr-MC": { "code": "fr-MC", "language": "French (Monaco)" },
  "fr-MF": { "code": "fr-MF", "language": "French (Saint Martin)" },
  "fr-MG": { "code": "fr-MG", "language": "French (Madagascar)" },
  "fr-ML": { "code": "fr-ML", "language": "French (Mali)" },
  "fr-MQ": { "code": "fr-MQ", "language": "French (Martinique)" },
  "fr-NE": { "code": "fr-NE", "language": "French (Niger)" },
  "fr-RE": { "code": "fr-RE", "language": "French (Réunion)" },
  "fr-RW": { "code": "fr-RW", "language": "French (Rwanda)" },
  "fr-SN": { "code": "fr-SN", "language": "French (Senegal)" },
  "fr-TD": { "code": "fr-TD", "language": "French (Chad)" },
  "fr-TG": { "code": "fr-TG", "language": "French (Togo)" },
  "fr-YT": { "code": "fr-YT", "language": "French (Mayotte)" },
  "fy": { "code": "fy", "language": "Western Frisian" },
  "fy-NL": { "code": "fy-NL", "language": "Western Frisian (Netherlands)" },
  "ga": { "code": "ga", "language": "Irish" },
  "ga-IE": { "code": "ga-IE", "language": "Irish (Ireland)" },
  "gd": { "code": "gd", "language": "Scottish Gaelic" },
  "gd-GB": { "code": "gd-GB", "language": "Scottish Gaelic (United Kingdom)" },
  "gl": { "code": "gl", "language": "Galician" },
  "gl-ES": { "code": "gl-ES", "language": "Galician (Spain)" },
  "gu": { "code": "gu", "language": "Gujarati" },
  "gu-IN": { "code": "gu-IN", "language": "Gujarati (India)" },
  "gv": { "code": "gv", "language": "Manx" },
  "gv-IM": { "code": "gv-IM", "language": "Manx (Isle of Man)" },
  "ha": { "code": "ha", "language": "Hausa" },
  "ha-GH": { "code": "ha-GH", "language": "Hausa (Ghana)" },
  "ha-NE": { "code": "ha-NE", "language": "Hausa (Niger)" },
  "ha-NG": { "code": "ha-NG", "language": "Hausa (Nigeria)" },
  "he": { "code": "he", "language": "Hebrew" },
  "he-IL": { "code": "he-IL", "language": "Hebrew (Israel)" },
  "hi": { "code": "hi", "language": "Hindi" },
  "hi-IN": { "code": "hi-IN", "language": "Hindi (India)" },
  "hr": { "code": "hr", "language": "Croatian" },
  "hr-HR": { "code": "hr-HR", "language": "Croatian (Croatia)" },
  "hu": { "code": "hu", "language": "Hungarian" },
  "hu-HU": { "code": "hu-HU", "language": "Hungarian (Hungary)" },
  "hy": { "code": "hy", "language": "Armenian" },
  "hy-AM": { "code": "hy-AM", "language": "Armenian (Armenia)" },
  "id": { "code": "id", "language": "Indonesian" },
  "id-ID": { "code": "id-ID", "language": "Indonesian (Indonesia)" },
  "ig": { "code": "ig", "language": "Igbo" },
  "ig-NG": { "code": "ig-NG", "language": "Igbo (Nigeria)" },
  "ii": { "code": "ii", "language": "Sichuan Yi" },
  "ii-CN": { "code": "ii-CN", "language": "Sichuan Yi (China)" },
  "is": { "code": "is", "language": "Icelandic" },
  "is-IS": { "code": "is-IS", "language": "Icelandic (Iceland)" },
  "it": { "code": "it", "language": "Italian" },
  "it-CH": { "code": "it-CH", "language": "Italian (Switzerland)" },
  "it-IT": { "code": "it-IT", "language": "Italian (Italy)" },
  "ja": { "code": "ja", "language": "Japanese" },
  "ja-JP": { "code": "ja-JP", "language": "Japanese (Japan)" },
  "ka": { "code": "ka", "language": "Georgian" },
  "ka-GE": { "code": "ka-GE", "language": "Georgian (Georgia)" },
  "ki": { "code": "ki", "language": "Kikuyu" },
  "ki-KE": { "code": "ki-KE", "language": "Kikuyu (Kenya)" },
  "kk": { "code": "kk", "language": "Kazakh" },
  "kk-KZ": { "code": "kk-KZ", "language": "Kazakh (Kazakhstan)" },
  "kl": { "code": "kl", "language": "Kalaallisut" },
  "kl-GL": { "code": "kl-GL", "language": "Kalaallisut (Greenland)" },
  "km": { "code": "km", "language": "Khmer" },
  "km-KH": { "code": "km-KH", "language": "Khmer (Cambodia)" },
  "kn": { "code": "kn", "language": "Kannada" },
  "kn-IN": { "code": "kn-IN", "language": "Kannada (India)" },
  "ko": { "code": "ko", "language": "Korean" },
  "ko-KR": { "code": "ko-KR", "language": "Korean (South Korea)" },
  "ks": { "code": "ks", "language": "Kashmiri" },
  "ks-IN": { "code": "ks-IN", "language": "Kashmiri (India)" },
  "kw": { "code": "kw", "language": "Cornish" },
  "kw-GB": { "code": "kw-GB", "language": "Cornish (United Kingdom)" },
  "ky": { "code": "ky", "language": "Kyrgyz" },
  "ky-KG": { "code": "ky-KG", "language": "Kyrgyz (Kyrgyzstan)" },
  "lg": { "code": "lg", "language": "Ganda" },
  "lg-UG": { "code": "lg-UG", "language": "Ganda (Uganda)" },
  "ln": { "code": "ln", "language": "Lingala" },
  "ln-CD": { "code": "ln-CD", "language": "Lingala (Congo - Kinshasa)" },
  "ln-CG": { "code": "ln-CG", "language": "Lingala (Congo - Brazzaville)" },
  "lo": { "code": "lo", "language": "Lao" },
  "lo-LA": { "code": "lo-LA", "language": "Lao (Laos)" },
  "lt": { "code": "lt", "language": "Lithuanian" },
  "lt-LT": { "code": "lt-LT", "language": "Lithuanian (Lithuania)" },
  "lu": { "code": "lu", "language": "Luba-Katanga" },
  "lu-CD": { "code": "lu-CD", "language": "Luba-Katanga (Congo - Kinshasa)" },
  "lv": { "code": "lv", "language": "Latvian" },
  "lv-LV": { "code": "lv-LV", "language": "Latvian (Latvia)" },
  "mg": { "code": "mg", "language": "Malagasy" },
  "mg-MG": { "code": "mg-MG", "language": "Malagasy (Madagascar)" },
  "mk": { "code": "mk", "language": "Macedonian" },
  "mk-MK": { "code": "mk-MK", "language": "Macedonian (Macedonia)" },
  "ml": { "code": "ml", "language": "Malayalam" },
  "ml-IN": { "code": "ml-IN", "language": "Malayalam (India)" },
  "mn": { "code": "mn", "language": "Mongolian" },
  "mn-MN": { "code": "mn-MN", "language": "Mongolian (Mongolia)" },
  "mr": { "code": "mr", "language": "Marathi" },
  "mr-IN": { "code": "mr-IN", "language": "Marathi (India)" },
  "ms": { "code": "ms", "language": "Malay" },
  "ms-BN": { "code": "ms-BN", "language": "Malay (Brunei)" },
  "ms-MY": { "code": "ms-MY", "language": "Malay (Malaysia)" },
  "mt": { "code": "mt", "language": "Maltese" },
  "mt-MT": { "code": "mt-MT", "language": "Maltese (Malta)" },
  "my": { "code": "my", "language": "Burmese" },
  "my-MM": { "code": "my-MM", "language": "Burmese (Myanmar (Burma))" },
  "nb": { "code": "nb", "language": "Norwegian Bokmål" },
  "nb-NO": { "code": "nb-NO", "language": "Norwegian Bokmål (Norway)" },
  "nd": { "code": "nd", "language": "North Ndebele" },
  "nd-ZW": { "code": "nd-ZW", "language": "North Ndebele (Zimbabwe)" },
  "ne": { "code": "ne", "language": "Nepali" },
  "ne-IN": { "code": "ne-IN", "language": "Nepali (India)" },
  "ne-NP": { "code": "ne-NP", "language": "Nepali (Nepal)" },
  "nl": { "code": "nl", "language": "Dutch" },
  "nl-AW": { "code": "nl-AW", "language": "Dutch (Aruba)" },
  "nl-BE": { "code": "nl-BE", "language": "Dutch (Belgium)" },
  "nl-CW": { "code": "nl-CW", "language": "Dutch (Curaçao)" },
  "nl-NL": { "code": "nl-NL", "language": "Dutch (Netherlands)" },
  "nl-SX": { "code": "nl-SX", "language": "Dutch (Sint Maarten)" },
  "nn": { "code": "nn", "language": "Norwegian Nynorsk" },
  "nn-NO": { "code": "nn-NO", "language": "Norwegian Nynorsk (Norway)" },
  "no": { "code": "no", "language": "Norwegian" },
  "om": { "code": "om", "language": "Oromo" },
  "om-ET": { "code": "om-ET", "language": "Oromo (Ethiopia)" },
  "om-KE": { "code": "om-KE", "language": "Oromo (Kenya)" },
  "or": { "code": "or", "language": "Oriya" },
  "or-IN": { "code": "or-IN", "language": "Oriya (India)" },
  "os": { "code": "os", "language": "Ossetic" },
  "os-GE": { "code": "os-GE", "language": "Ossetic (Georgia)" },
  "os-RU": { "code": "os-RU", "language": "Ossetic (Russia)" },
  "pa": { "code": "pa", "language": "Punjabi" },
  "pa-IN": { "code": "pa-IN", "language": "Punjabi (India)" },
  "pa-PK": { "code": "pa-PK", "language": "Punjabi (Pakistan)" },
  "pl": { "code": "pl", "language": "Polish" },
  "pl-PL": { "code": "pl-PL", "language": "Polish (Poland)" },
  "ps": { "code": "ps", "language": "Pashto" },
  "ps-AF": { "code": "ps-AF", "language": "Pashto (Afghanistan)" },
  "pt": { "code": "pt", "language": "Portuguese" },
  "pt-BR": { "code": "pt-BR", "language": "Portuguese (Brazil)" },
  "pt-GW": { "code": "pt-GW", "language": "Portuguese (Guinea-Bissau)" },
  "pt-MZ": { "code": "pt-MZ", "language": "Portuguese (Mozambique)" },
  "pt-PT": { "code": "pt-PT", "language": "Portuguese (Portugal)" },
  "qu": { "code": "qu", "language": "Quechua" },
  "qu-BO": { "code": "qu-BO", "language": "Quechua (Bolivia)" },
  "qu-EC": { "code": "qu-EC", "language": "Quechua (Ecuador)" },
  "qu-PE": { "code": "qu-PE", "language": "Quechua (Peru)" },
  "rm": { "code": "rm", "language": "Romansh" },
  "rm-CH": { "code": "rm-CH", "language": "Romansh (Switzerland)" },
  "rn": { "code": "rn", "language": "Rundi" },
  "rn-BI": { "code": "rn-BI", "language": "Rundi (Burundi)" },
  "ro": { "code": "ro", "language": "Romanian" },
  "ro-MD": { "code": "ro-MD", "language": "Romanian (Moldova)" },
  "ro-RO": { "code": "ro-RO", "language": "Romanian (Romania)" },
  "ru": { "code": "ru", "language": "Russian" },
  "ru-MD": { "code": "ru-MD", "language": "Russian (Moldova)" },
  "ru-RU": { "code": "ru-RU", "language": "Russian (Russia)" },
  "ru-UA": { "code": "ru-UA", "language": "Russian (Ukraine)" },
  "rw": { "code": "rw", "language": "Kinyarwanda" },
  "rw-RW": { "code": "rw-RW", "language": "Kinyarwanda (Rwanda)" },
  "sg": { "code": "sg", "language": "Sango" },
  "sg-CF": { "code": "sg-CF", "language": "Sango (Central African Republic)" },
  "si": { "code": "si", "language": "Sinhala" },
  "si-LK": { "code": "si-LK", "language": "Sinhala (Sri Lanka)" },
  "sk": { "code": "sk", "language": "Slovak" },
  "sk-SK": { "code": "sk-SK", "language": "Slovak (Slovakia)" },
  "sl": { "code": "sl", "language": "Slovenian" },
  "sl-SI": { "code": "sl-SI", "language": "Slovenian (Slovenia)" },
  "sn": { "code": "sn", "language": "Shona" },
  "sn-ZW": { "code": "sn-ZW", "language": "Shona (Zimbabwe)" },
  "so": { "code": "so", "language": "Somali" },
  "so-DJ": { "code": "so-DJ", "language": "Somali (Djibouti)" },
  "so-ET": { "code": "so-ET", "language": "Somali (Ethiopia)" },
  "so-KE": { "code": "so-KE", "language": "Somali (Kenya)" },
  "so-SO": { "code": "so-SO", "language": "Somali (Somalia)" },
  "sq": { "code": "sq", "language": "Albanian" },
  "sq-AL": { "code": "sq-AL", "language": "Albanian (Albania)" },
  "sr": { "code": "sr", "language": "Serbian" },
  "sr-BA": { "code": "sr-BA", "language": "Serbian (Bosnia and Herzegovina)" },
  "sr-ME": { "code": "sr-ME", "language": "Serbian (Montenegro)" },
  "sr-RS": { "code": "sr-RS", "language": "Serbian (Serbia)" },
  "sv": { "code": "sv", "language": "Swedish" },
  "sv-AX": { "code": "sv-AX", "language": "Swedish (Åland Islands)" },
  "sv-FI": { "code": "sv-FI", "language": "Swedish (Finland)" },
  "sv-SE": { "code": "sv-SE", "language": "Swedish (Sweden)" },
  "sw": { "code": "sw", "language": "Swahili" },
  "sw-KE": { "code": "sw-KE", "language": "Swahili (Kenya)" },
  "sw-TZ": { "code": "sw-TZ", "language": "Swahili (Tanzania)" },
  "ta": { "code": "ta", "language": "Tamil" },
  "ta-IN": { "code": "ta-IN", "language": "Tamil (India)" },
  "ta-LK": { "code": "ta-LK", "language": "Tamil (Sri Lanka)" },
  "te": { "code": "te", "language": "Telugu" },
  "te-IN": { "code": "te-IN", "language": "Telugu (India)" },
  "th": { "code": "th", "language": "Thai" },
  "th-TH": { "code": "th-TH", "language": "Thai (Thailand)" },
  "ti": { "code": "ti", "language": "Tigrinya" },
  "ti-ER": { "code": "ti-ER", "language": "Tigrinya (Eritrea)" },
  "ti-ET": { "code": "ti-ET", "language": "Tigrinya (Ethiopia)" },
  "to": { "code": "to", "language": "Tongan" },
  "to-TO": { "code": "to-TO", "language": "Tongan (Tonga)" },
  "tr": { "code": "tr", "language": "Turkish" },
  "tr-TR": { "code": "tr-TR", "language": "Turkish (Turkey)" },
  "tt": { "code": "tt", "language": "Tatar" },
  "tt-RU": { "code": "tt-RU", "language": "Tatar (Russia)" },
  "ug": { "code": "ug", "language": "Uyghur" },
  "ug-CN": { "code": "ug-CN", "language": "Uyghur (China)" },
  "uk": { "code": "uk", "language": "Ukrainian" },
  "uk-UA": { "code": "uk-UA", "language": "Ukrainian (Ukraine)" },
  "ur": { "code": "ur", "language": "Urdu" },
  "ur-IN": { "code": "ur-IN", "language": "Urdu (India)" },
  "ur-PK": { "code": "ur-PK", "language": "Urdu (Pakistan)" },
  "uz": { "code": "uz", "language": "Uzbek" },
  "uz-AF": { "code": "uz-AF", "language": "Uzbek (Afghanistan)" },
  "uz-UZ": { "code": "uz-UZ", "language": "Uzbek (Uzbekistan)" },
  "vi": { "code": "vi", "language": "Vietnamese" },
  "vi-VN": { "code": "vi-VN", "language": "Vietnamese (Vietnam)" },
  "yo": { "code": "yo", "language": "Yoruba" },
  "yo-NG": { "code": "yo-NG", "language": "Yoruba (Nigeria)" },
  "zh": { "code": "zh", "language": "Chinese" },
  "zh-CN": { "code": "zh-CN", "language": "Chinese (China)" },
  "zh-HK": { "code": "zh-HK", "language": "Chinese (Hong Kong)" },
  "zh-MO": { "code": "zh-MO", "language": "Chinese (Macau)" },
  "zh-SG": { "code": "zh-SG", "language": "Chinese (Singapore)" },
  "zh-TW": { "code": "zh-TW", "language": "Chinese (Taiwan)" },
  "zu": { "code": "zu", "language": "Zulu" },
  "zu-ZA": { "code": "zu-ZA", "language": "Zulu (South Africa)" }
}
